import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';
import { getTotalSalesByMonth } from '../../slices/dashboard';
import { useSelector, useDispatch } from 'react-redux'
import 'chartjs-adapter-moment';
import moment from 'moment';
import { daysInMonth } from '../../utils';
moment.locale('is');

const BarChart = () => {
    const chartRef = useRef();
    const totalSalesByMonth = useSelector((state) => state.dashboard.totalSalesByMonth);
    const totalSalesByMonthLoading = useSelector((state) => state.dashboard.totalSalesByMonthLoading || false);

    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getTotalSalesByMonth())
    }, [])

    const convertData = (data, comparison = false) => {
        let _currentPeriod = {}
        data?.data?.sales?.map((currency) => {
            currency.data.map((month) => {
                if (Object.keys(_currentPeriod).includes(month.month)) {
                    _currentPeriod[month.month] += month.total
                } else {
                    _currentPeriod[month.month] = month.total
                }
            })
        })
        return Object.keys(_currentPeriod).map((month) => {
            let d = moment(month)
            if (comparison) {
                d.add(1, 'year')
            }
            return { 'x': d.format('YYYY-MM-DDTHH:mm:ss'), 'y': _currentPeriod[month] }
        })
    }

    const currentPeriod = convertData(totalSalesByMonth?.current)
    const comparisonPeriod = convertData(totalSalesByMonth?.comparison, true)
    let forecast = Object.assign({}, currentPeriod[currentPeriod.length -1])

    if (forecast && moment(forecast.x).month() === (new Date()).getMonth()) {
        forecast.y = (forecast.y / (new Date().getDate())) * daysInMonth(new Date()) - forecast.y
    } else {
        forecast = undefined
    }

    useEffect(() => {

        let datasets = [
            {
                label: gettext('Last 12 months'),
                data: currentPeriod,
                backgroundColor: '#84BFD0',
                borderColor: '#84BFD0',
                borderWidth: 1,
                barPercentage: 1.5,
                categoryPercentage: -0.5,
                stack: 'Stack 0',
            },
            {
                label: gettext('Year before'),
                data: comparisonPeriod,
                backgroundColor: '#D8D8D8',
                borderColor: '#D8D8D8',
                borderWidth: 1,
                barPercentage: 1.5,
                categoryPercentage: -0.5,
                stack: 'stack 1',
            },
        ]
        if (forecast) {
            datasets.splice(1, 0, {
                label: gettext('Forecast'),
                data: [forecast],
                backgroundColor: '#84BFD066',
                borderColor: '#84BFD066',
                borderWidth: 1,
                barPercentage: 1.5,
                categoryPercentage: -0.5,
                stack: 'Stack 0',
            })
        }

        const chart = new Chart(chartRef.current, {
            type: 'bar',
            data: {
                datasets: datasets,
            },
            options: {
                scales: {
                    x: {
                        type: 'time',
                        // add this: 
                        stacked: true,
                        time: {
                            tooltipFormat: 'MMMM',
                            unit: 'month',
                            displayFormats: {
                                'month': 'MMM \'YY'
                            }
                        }
                    },
                    y: {
                        stacked: true,
                        beginAtZero: true,
                    },
                },
                plugins: {
                    legend: {
                        display: false,
                    },
                }
            },
        });

        return () => {
            chart.destroy();
        };
    }, [totalSalesByMonth]);

    return (
        <>
            {totalSalesByMonthLoading === true ?
                <div className="loader top-50 start-50 position-absolute" role="status"></div>
                :
                <canvas ref={chartRef} />
            }
        </>);
};

export default BarChart;